"use client";

import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

interface QRCodeProps {
  url: string;
  size?: number | string;
  className?: string;
}

export default function QRCode({ url, size = 48, className = '' }: QRCodeProps) {
  return (
    <QRCodeSVG
      value={url}
      size={size as any}
      level="H" // 高错误纠正级别（约30%容错），提高扫描成功率
      includeMargin={true}
      marginSize={2} // 增加边距，确保有足够的空白区域
      className={className}
      style={{
        display: 'block',
      }}
    />
  );
}
